import axios from 'axios';

const api_get_dir = process.env.REACT_APP_API_URL+"/api/browse/directory";
const api_get_favorites = process.env.REACT_APP_API_URL+"/api/browse/directory/favorites";
const api_set_favorites = process.env.REACT_APP_API_URL+"/api/browse/favorites";
const api_resolve_path = process.env.REACT_APP_API_URL+"/api/browse/path";
const api_resolve_shared_path = process.env.REACT_APP_API_URL+"/api/browse/path/shared";
const api_resolve_favorites_path = process.env.REACT_APP_API_URL+"/api/browse/path/favorites";
const api_get_prog = process.env.REACT_APP_API_URL+"/api/browse/progress";
const api_get_file = process.env.REACT_APP_API_URL+"/api/browse/download";
const api_upload_file = process.env.REACT_APP_API_URL+"/api/browse/upload";
const api_rename_file = process.env.REACT_APP_API_URL+"/api/browse/rename";
const api_delete_file = process.env.REACT_APP_API_URL+"/api/browse/delete";
const api_create_item = process.env.REACT_APP_API_URL+"/api/browse/create";
const api_copy_item = process.env.REACT_APP_API_URL+"/api/browse/copy";
const api_move_file = process.env.REACT_APP_API_URL+"/api/browse/move";
const api_share_file = process.env.REACT_APP_API_URL+"/api/browse/share";
const api_set_share_with = process.env.REACT_APP_API_URL+"/api/browse/share/item";
const api_get_shared_item = process.env.REACT_APP_API_URL+"/api/browse/directory/shared";
const api_get_enabled_users = process.env.REACT_APP_API_URL+"/api/browse/users";
const api_preview_file = process.env.REACT_APP_API_URL+"/api/browse/preview";

const api_get_user = process.env.REACT_APP_API_URL+"/api/management/user";
const api_get_all_users = process.env.REACT_APP_API_URL+"/api/management/users";
const api_update_username = process.env.REACT_APP_API_URL+"/api/management/update-username";
const api_update_email = process.env.REACT_APP_API_URL+"/api/management/update-email";
const api_update_password = process.env.REACT_APP_API_URL+"/api/management/update-password";
const api_delete_account = process.env.REACT_APP_API_URL+"/api/management/delete-account";
const api_add_user = process.env.REACT_APP_API_URL+"/api/management/add-user";
const api_update_user = process.env.REACT_APP_API_URL+"/api/management/update-user";

const api_add_ip = process.env.REACT_APP_API_URL+"/api/visitor/add";
const api_get_ip = process.env.REACT_APP_API_URL+"/api/visitor/get";
const ip_get_1 = 'https://hutils.loxal.net/whois';
const ip_get_2 = 'https://geolocation-db.com/json/';

/*
 Location API calls
*/
function addIpAddress(type = 1) {
    if (type === 1) {
        return axios.get(ip_get_1)
        .then((res) => {
            return axios
            .post(api_add_ip, 
                {
                    'database': 'imperiumcloud',
                    'collection': 'visitors',
                    'ip': res.data.ip,
                    'location': res.data.country,
                    'last_visited': Date.now()
                }
            )
            .then((response) => {
                return response;
            })
            .catch(() => {                
                return false
            });
        })
        .catch(() => {
            return false
        });
    } else {
        return axios.get(ip_get_2)
        .then((res) => {
            return axios
            .post(api_add_ip, 
                {
                    'database': 'imperiumcloud',
                    'collection': 'visitors',
                    'ip': res.data.IPv4,
                    'location': res.data.country_name,
                    'last_visited': Date.now()
                }
            )
            .then((response) => {
                return response;
            })
            .catch(() => {                           
                return false
            });
        })
        .catch(() => {
            return false
        });
    }
}

function getIpAddress(token, filter = {}, sort = {}, limit = 0) {
    return axios
    .post(api_get_ip, 
        {
            'database': 'imperiumcloud',
            'collection': 'visitors',
            'token': token,
            'filter': filter,
            'sort': sort,
            'limit': limit
        }
    )
    .then((response) => {
        return response;
    })
    .catch(() => {});
}

/*
 File stuff
*/
function getDirecotryInfo(userID, token, currentDir) {
    return axios
        .post(api_get_dir, 
            {
              userID, 
              token,
              currentDir,
            }
        )
        .then((response) => {
            return response
        })
        .catch(() => { });
}

function resolveFavoritesPath(userID, token, path) {
  return axios.post(`${api_resolve_favorites_path}`, { userID, token, path });
}

function setFavorites(userId, token, itemId, favorite) {
  return axios.post(`${api_set_favorites}`, {
    userID: userId,
    token: token,
    itemId: itemId,
    favorite: favorite
  });
}

function getFavorites(userID, token, itemId = null) {
  return axios.post(
    `${api_get_favorites}`, // Define this URL
    {
      userID,
      token,
      itemId,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );
}

function resolveFolderPath(userID, token, path) {
  return axios.post(api_resolve_path, {
    userID,
    token,
    path
  });
}

function resolveSharedPath(userID, token, path) {
  return axios.post(api_resolve_shared_path, {
    userID,
    token,
    path
  });
}

function downloadFile(userID, token, currentDir, fileName, id, onDownloadProgress, cancelToken) {
    return axios.post(api_get_file, 
      {                        
        userID, 
        token,
        currentDir,
        fileName,
        id
      },
      {
        responseType: 'blob',
        onDownloadProgress: onDownloadProgress,
        cancelToken: cancelToken,
      }
    );
}

function downloadProgress(userID, token, id) {
    return axios
        .post(api_get_prog, 
            {
              userID, 
              token,
              id
            }
        )
        .then((response) => {
            return response
        })
        .catch(() => { });
}

function uploadFile(userID, token, currentDirectory, fileName, file, config = {}) {
    const formData = new FormData();
    formData.append('userID', userID);
    formData.append('token', token);
    console.log(currentDirectory)
    formData.append("currentDir", currentDirectory);
    formData.append("fileName", fileName)
    formData.append("file", file);
  
    return axios.post(api_upload_file, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "cache-control": "no-cache",
      },
      ...config,
    });
}

function renameFile(userID, token, itemId, newName) {
  return axios.post(
    api_rename_file,
    {
      userID, 
      token,
      itemId,
      newName,
    },
    {
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    }
  );
}

function deleteFile(userID, token, itemId) {
  return axios.post(
    api_delete_file,
    {
      userID, 
      token,
      itemId
    },
    {
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    }
  );
}

function createItem(userID, token, parentId, folderName) {
  return axios.post(
    api_create_item,
    {
      userID, 
      token,
      parentId,
      folderName,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
}

function copyItem(userID, token, itemId, targetParentId) {
  return axios.post(
    api_copy_item,
    {
      userID, 
      token,
      itemId,
      targetParentId,
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
}

function moveItem(userID, token, itemId, destinationId) {
  return axios.post(
    api_move_file,
    {
      userID, 
      token,
      itemId,
      destinationId
    },
    {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, // if you're using token-based auth
      },
    }
  );
}

function createShare(userID, token, itemId, expirationTime) {
  return axios.post(
    api_share_file,
    {
      userID, 
      token,
      itemId,
      expirationTime
    },
    {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`, // if you're using token-based auth
      },
    }
  );
}

function previewFile(userID, token, itemId) {
  return axios.get(
    `${api_preview_file}`, {
      params: {
        userID,
        token,
        itemId
      },
      headers: {
        headers: {
          "Authorization": `Bearer ${token}`, // if you're using token-based auth
        },
      }
    }
  );
}

function shareItemWithUsers(userID, token, itemId, sharedWithUserIDs) {
  return axios.post(
    `${api_set_share_with}`, // Replace with your actual backend endpoint path
    {
      userID,
      token,
      itemId,
      shareWith: sharedWithUserIDs
    },
    {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );
}

function getSharedItems(userID, token, itemId = null) {
  return axios.post(
    `${api_get_shared_item}`, // Replace with your actual backend endpoint path
    {
      userID,
      token,
      itemId,
    },
    {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    }
  );
}


/*

 Management API calls

*/

function getAccountInfo(id) {
    return axios
        .post(api_get_user, 
            {
                'database': 'imperiumcloud',
                'collection': 'astartes',
                'filter': {'_id': id},
            }
        )
        .then((response) => {
            return response;
        })
        .catch(() => { });
}

function getAllUsers(adminId) {
    return axios
      .post(api_get_all_users, {
        database: 'imperiumcloud',
        collection: 'astartes',
        adminId: adminId, // Pass the admin's ID here
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
}

function getAllEnabledUsers(userID, token) {
  return axios
    .post(api_get_enabled_users, {
      userID,
      token,
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching users:", error);
    });
}

/*

USER MODIFICATIONS

*/

function createNewUser(adminId, userData) {
    return axios
    .post(api_add_user, {
      database: "imperiumcloud",
      collection: "astartes",
      adminId: adminId,
      user: userData,
      update: false,
    })
    .then((response) => response)
    .catch((error) => console.error("Error creating user:", error));
}

function updateUser(adminId, userData) {
    return axios
    .post(api_update_user, {
      database: "imperiumcloud",
      collection: "astartes",
      adminId: adminId,
      user: userData
    })
    .then((response) => response)
    .catch((error) => console.error("Error creating user:", error));
}

function updateUsername(userId, newUsername) {
  return axios
    .post(api_update_username, {
      database: "imperiumcloud",
      collection: "astartes",
      userId: userId,
      newUsername: newUsername,
    })
    .then((response) => response)
    .catch((error) => console.error("Error updating username:", error));
}

function updateEmail(userId, newEmail) {
  return axios
    .post(api_update_email, {
      database: "imperiumcloud",
      collection: "astartes",
      userId: userId,
      email: newEmail,
    })
    .then((response) => response)
    .catch((error) => console.error("Error updating email:", error));
}

function changePassword(userId, currentPassword, newPassword) {
  return axios
    .post(api_update_password, {
      database: "imperiumcloud",
      collection: "astartes",
      userId: userId,
      currentPassword: currentPassword,
      newPassword: newPassword,
    })
    .then((response) => response)
    .catch((error) => console.error("Error changing password:", error));
}

function deleteAccount(userId) {
  return axios
    .post(api_delete_account, {
      database: "imperiumcloud",
      collection: "astartes",
      userId: userId,
    })
    .then((response) => response)
    .catch((error) => console.error("Error deleting account:", error));
}

const API = {
    addIpAddress,
    getIpAddress,
    getAccountInfo,
    getAllUsers,
    getDirecotryInfo,
    getFavorites,
    setFavorites,
    resolveFolderPath,
    resolveSharedPath,
    resolveFavoritesPath,
    uploadFile,
    renameFile,
    deleteFile,
    copyItem,
    createItem,
    moveItem,
    createShare,
    shareItemWithUsers,
    getSharedItems,
    getAllEnabledUsers,
    previewFile,
    downloadFile,
    downloadProgress,
    updateUsername,
    updateEmail,
    changePassword,
    deleteAccount,
    createNewUser,
    updateUser,
}

export default API;